export default "__VITE_ASSET__CfTuXMAk__"